import LocalizedAppContent from './LocalizedAppContent'

export default LocalizedAppContent
